module.exports = __webpack_public_path__ + "static/media/S (171).2dcdc511.jpg";